import React from "react";
import Dropdown from "../Dropdown";

class UserDashboardDropdown extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var options = this.props.dashboards.map(function (dashboard) {
      return (
        <option value={dashboard["id"]} key={dashboard["id"]}>{`${I18n.t(
          "dashboard_viewer"
        )}: ${dashboard["name"]}`}</option>
      );
    });

    return (
      <div className="UserDashboardDropdown">
        <select
          className="form-control dashboard-select"
          value={this.props.dashboard_id}
          onChange={this.props.onChangeDashboard}
        >
          {options}
        </select>
      </div>
    );
  }
}

export default UserDashboardDropdown;
